import { schCompType } from '@aloft/toolkit-shared';
import { Flex, RadioGroup, Typography } from '@aloft/toolkit-sui';

import { Controller, FormProvider } from 'react-hook-form';

import { AddressInputs } from '../../../../../components/AddressInput/AddressInputs.js';
import { MLSInputs } from '../../../../../components/MLSInput/MLSInputs.js';

import {
  selectHasArvOption,
} from '../../../../../redux/features/selectors/orderSelectors.ts';
import { useAppSelector } from '../../../../../redux/hooks.ts';
import { AddCompsFormProps } from '../types.ts';

export const AddCompsForm = ({ form }: AddCompsFormProps) => {
  const hasArvOption = useAppSelector(selectHasArvOption);

  return (
    <Flex width="100%" height="100%" gap={3} flexDirection="column">
      <FormProvider {...form}>
        <Flex>
          <Typography variant="body1">Toolkit will import data from MLS data and/or county records to autofill certain fields. You can still edit these fields.</Typography>
        </Flex>
        <Flex gap={3} flexDirection="column">
          <AddressInputs />
          <MLSInputs />
        </Flex>
        {hasArvOption && (
          <Controller
            control={form.control}
            key="compType"
            name="compType"
            render={({ field }) => (
              <RadioGroup
                isRequired
                label="Valuation Type"
                size="lg"
                forceHorizontal
                columnGap="2rem"
                items={[
                  { label: 'As-Is Value', value: schCompType.enum.aiv },
                  { label: 'After Repair Value', value: schCompType.enum.arv },
                ]}
                value={field.value}
                onChange={field.onChange}
              />
            )}
          />
        )}
      </FormProvider>
    </Flex>
  );
};
